module.exports = __webpack_public_path__ + "a606c8c9fb89e30fbd0ef6af6fa1c6ab.svg";